export const catalogueitemConstants = {
    GETALL_REQUEST: 'CATALOGUEITEM_GETALL_REQUEST',
    GETALL_SUCCESS: 'CATALOGUEITEM_GETALL_SUCCESS',
    GETALL_FAILURE: 'CATALOGUEITEM_GETALL_FAILURE',

    DELETE_REQUEST: 'CATALOGUEITEM_DELETE_REQUEST',
    DELETE_SUCCESS: 'CATALOGUEITEM_DELETE_SUCCESS',
    DELETE_FAILURE: 'CATALOGUEITEM_DELETE_FAILURE'
};
